var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('swatches',_vm._b({attrs:{"swatches":"text-advanced"},model:{value:(_vm.colorModel),callback:function ($$v) {_vm.colorModel=$$v},expression:"colorModel"}},'swatches',_vm.$attrs,false)),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.inputName},domProps:{"value":_vm.colorModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }